import classNames from 'classnames'
import React from 'react'
import { Outlet } from 'react-router'

import { Aside } from '@components/Aside'
import { Footer } from '@components/Footer'
import { Header } from '@components/Header'

import { useAppSelector } from '@store/hooks'

import type { BaseLayoutProps } from './BaseLayout.props'

export function BaseLayout({ variant = 'base' }: BaseLayoutProps) {
  const { asideShow } = useAppSelector((state) => state.global)

  return (
    <>
      <div className={'body-mob-fixed'}>
        <div className={`${variant}-layout`}>
          <Aside />
          <main className={classNames('main', { 'main--active': asideShow })}>
            <Header />
            <Outlet />
          </main>
        </div>
      </div>

      <Footer />
    </>
  )
}
